import Model, { IsoDateTime } from 'src/models/Model'

export default class DisputeEvidence extends Model {
  static name = 'DisputeEvidence'

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static define () {
    this.fields = {
      disputeCode: {
        type: String,
        input: true
      },
      cancellationPolicyDisclosure: {
        type: String,
        default: null
      },
      cancellationRebuttal: {
        type: String,
        default: null
      },
      customerEmailAddress: {
        type: String,
        default: null
      },
      customerName: {
        type: String,
        default: null
      },
      productDescription: {
        type: String,
        default: null
      },
      refundPolicyDisclosure: {
        type: String,
        default: null
      },
      refundRefusalExplanation: {
        type: String,
        default: null
      },
      serviceDate: {
        type: IsoDateTime,
        default: null
      },
      uncategorizedText: {
        type: String,
        default: null
      },
      customerCommunicationBlob: {
        type: String,
        default: null,
        input: true
      },
      serviceDocumentationBlob: {
        type: String,
        default: null,
        input: true
      },
      uncategorizedFileBlob: {
        type: String,
        default: null,
        input: true
      }
    }
  }
}
